












import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';

@Component
export default class PopoverMenu extends Vue {
  @Prop() private title!: string;
}
